import React from 'react';
import { LinkContainer } from 'react-router-bootstrap';

/**
 * Sets all link container params.
 *
 * @param path path to component.
 * @param name name of button in navbar.
 * @param eventKey number of item in navbar.
 * @param className name of class for icon
 * @returns button in navbar component with link.
 */
const NavLink = props => (
    <LinkContainer to={props.path}>
        <div>
            <i className={props.className} />
            {' ' + props.name}
        </div>
    </LinkContainer>
);

export default NavLink;



// WEBPACK FOOTER //
// ./src/components/Navbar/NavLink.js